import script from "./UserInfoGlobal.vue?vue&type=script&lang=js"
export * from "./UserInfoGlobal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__